module.exports = __webpack_public_path__ + "img/93.fea60017.jpg";